'use client'

import { type FC, type PropsWithChildren, type ReactNode } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

import { apmCaptureError } from '../apm'

import { ErrorBoundaryError } from './ErrorBoundaryError'

type ErrorBoundaryProps = PropsWithChildren<{
  fallback?: ReactNode
}>

export const ErrorBoundary: FC<ErrorBoundaryProps> = ({
  children,

  /**
   * `ReactErrorBoundary` expects `fallback`, `FallbackComponent` or `fallbackRender`
   * to display visual feedback for a user. But current React versions support `undefined` rendering https://github.com/reactwg/react-18/discussions/75.
   * `ReactErrorBoundary` still has the check for `undefined` value https://github.com/bvaughn/react-error-boundary/blob/23167c532dd6da0b8f106ab6ff8705ff64de81eb/src/ErrorBoundary.ts#L97-L107
   * to force developers to provide a fallback.
   */
  fallback = null,
}) => (
  <ReactErrorBoundary
    fallback={fallback}
    onError={(error) => {
      apmCaptureError(new ErrorBoundaryError(error))
    }}
  >
    {children}
  </ReactErrorBoundary>
)
